import { Injectable, signal } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class FlatrateExemptionService {
	private readonly showDetailSubject: Subject<boolean> = new Subject<boolean>();
	showDetail$: Observable<boolean> = this.showDetailSubject.asObservable();
	readonly selectedType = signal('');

	activateView(exemptionOrFlatrate: 'FLATRATE' | 'EXEMPTION') {
		this.showDetailSubject.next(true);
		this.selectedType.set(exemptionOrFlatrate);
	}

	deactivateView() {
		this.showDetailSubject.next(false);
		this.selectedType.set(null);
	}
}
